import React from 'react';
import { useSelector } from 'react-redux';
import { DiscountType, IntentType, } from '@debbie/common/dist/intents';
const DepositIntent = (props) => {
    const lang = useSelector((s) => s.lang);
    const discountStatement = props.intent.discount != null
        ? props.intent.discount.type === DiscountType.Amount
            ? `${props.intent.discount.amount / 100} ${lang.intents.discount}`
            : `${props.intent.discount.fraction * 100}% ${lang.intents.discount}`
        : null;
    return (React.createElement("div", null,
        lang.intents.intent,
        ": ",
        lang.intentTypes[IntentType.Deposit],
        " (",
        props.intent.collectionPeriod,
        " ",
        lang.intents.days,
        discountStatement != null ? `, ${discountStatement}` : '',
        ")"));
};
export default DepositIntent;
//# sourceMappingURL=DepositIntent.js.map